export async function fetchProfileData() {
  const notifications = [
    { label: "Push Notifications", enabled: false, icon: "pushnotifications" },
    { label: "Transaction Alerts", enabled: false, icon: "transactionalerts" },
    { label: "Account Alerts", enabled: false, icon: "accountalerts" },
    { label: "Email Alerts", enabled: false, icon: "emailalerts" },
    { label: "Do Not Disturb", enabled: true, icon: "donotdisturb" },
  ];

  return {
    settings: {
      notifications,
      security: [
        { label: "Change Password", type: "update", icon: "mpinprofile" },
        {
          label: "Security Questions",
          type: "update",
          icon: "securityquestions",
        },
      ],
      privacy: [{ label: "Data Sharing", enabled: true, icon: "datasharing" }],
      support: [
        { label: "FAQs", type: "View", icon: "faqs" },
        { label: "Tutorials", type: "Watch", icon: "tutorials" },
        { label: "Contact Us", type: "View", icon: "appsupport" },
        { label: "Report an Issue", type: "Submit", icon: "reportanissue" },
        { label: "Feedback", type: "Share", icon: "feedback" },
        { label: "About us", type: "View", icon: "about" },
      ],
    },
  };
}
